import Minicart from "./minicart"
import Helpers from "../helpers"

//import slick from 'slick-carousel';

const Product = {
  product_images: null,
  init: function () {
    window.addEventListener(
      "popstate",
      function (event) {
        var variant_id = Helpers.getUrlParam(window.location.href, "variant")
        $(
          '.variants .select-item[data-variant-id="' + variant_id + '"]'
        ).trigger("click")
      },
      false
    )

    $(".formCartAdd").submit(function (e) {
      e.preventDefault()

      let requestData = $(this).serialize()

      const isPreorder = e.currentTarget.hasAttribute("data-preorder")
      if (isPreorder) {
        const formData = new FormData(e.currentTarget)

        if (formData.get("purchase_type") != "onetime") {
          const elSelect = document.querySelector(
            '[name="properties[shipping_interval_frequency]"]'
          )

          formData.set("properties[original_frequency]", elSelect.value)
          formData.set("properties[shipping_interval_frequency]", 365 * 2)

          requestData = new URLSearchParams(formData).toString()
        } else {
          formData.delete("properties[original_frequency]")
          requestData = new URLSearchParams(formData).toString()
        }
      }

      $.ajax({
        type: "POST",
        url: "/cart/add.js",
        dataType: "json",
        data: requestData,
        success: () => {
          $.getJSON("/cart.js", function (cart) {
            $(".modal, #overlay").fadeOut(250)
            $("body").removeClass("fixed")
            Minicart.checkForGift(cart, true)
            // Minicart.updateMinicart(cart, true);
          })
        },
        error: (XMLHttpRequest, textStatus) => {
          var data = eval("(" + XMLHttpRequest.responseText + ")")
          if (!!data.message) {
            alert(data.message + "(" + data.status + "): " + data.description)
          } else {
            alert(
              "Error : " + Shopify.fullMessagesFromErrors(data).join("; ") + "."
            )
          }
        },
      })
    })

    $(".prev-month").click(function () {
      if ($(".more-than-4-months").is(":visible")) {
        $(".month").removeClass("hide")
        $(".more-than-4-months").addClass("hide")
      } else {
        if ($(".month.selected").index(".month") != 0) {
          var $newMonth = $(".month.selected").prev()
          $(".month.selected").removeClass("selected")
          $newMonth.addClass("selected")
          $(".next-month").css("visibility", "visible")
        }
        if ($(".month.selected").index(".month") == 0) {
          $(".prev-month").css("visibility", "hidden")
        }
      }
    })

    $(".next-month").click(function () {
      if ($(".month.selected").index(".month") < 3) {
        var $newMonth = $(".month.selected").next()
        $(".month.selected").removeClass("selected")
        $newMonth.addClass("selected")
        $(".prev-month").css("visibility", "visible")
      }
      if ($(".month.selected").index(".month") == 3) {
        $(".next-month").css("visibility", "hidden")
      }
    })

    $(".too-far-out").click(function () {
      console.log("show too far")
      $(".month").addClass("hide")
      $(".more-than-4-months").removeClass("hide")
    })

    $(".month .date").click(function () {
      if ($(this).hasClass("disabled")) return
      $(".month .date").removeClass("selected")
      $(this).addClass("selected")
      $("#shipping_date").val(
        $(this).attr("data-month-readable") +
          " " +
          $(this).attr("data-day") +
          ", " +
          $(this).attr("data-year")
      )
    })

    $("body").mouseup(function (e) {
      if (!$("#calendar").is(":visible")) return
      var container = $("#calendar")

      // if the target of the click isn't the container nor a descendant of the container
      if (!container.is(e.target) && container.has(e.target).length === 0) {
        container.addClass("hide")
      }
    })

    $(".variant_select").click(function () {
      if ($(this).attr("data-option1") != undefined) {
        $(
          '.variants .select-item[data-option1="' +
            $(this).attr("data-option1") +
            '"][data-option2="' +
            $(this).attr("data-option2") +
            '"][data-option3="' +
            $(this).attr("data-option3") +
            '"]'
        ).trigger("click")
      } else {
        $(
          '.variants .select-item[data-variant-title="' +
            $(this).attr("data-variant-title") +
            '"]'
        ).trigger("click")
      }
    })

    $(".variants .select-item").click(function () {
      if ($(this).hasClass("unavailable")) {
        $("#BIS_trigger").removeClass("hide")
        $(".add-to-cart").addClass("hide")

        return
      }

      $("#BIS_trigger").addClass("hide")
      $(".add-to-cart").removeClass("hide")
      $(".add-to-cart").removeAttr("disabled")
      $(".addToCartText").html($(".addToCartText").attr("data-label"))
      $(".addToCartPrice").removeClass("hide")

      $(this).closest(".potencies").find(".potency").removeClass("selected")
      $(this).addClass("selected")

      Product.updateForms(this)
    })

    // Variants (count > 3) selector
    $(`.select-container > .select-item`)
      .off("click")
      .on("click", function (e) {
        //console.trace("T1")
        e.preventDefault()

        var $variant = $(this),
          variant_title = $variant.data("variant-title"),
          variant_id = $variant.data("variant-id"),
          $wrapper = $variant.closest(".select-container"),
          $form = $variant.closest("form"),
          product_id = $form.data("productid")

        console.log($form, product_id, variant_id)

        // Update Selector
        $wrapper.find(".selected-item span").text(variant_title)
        $wrapper.find(".select-item").removeClass("selected")
        $wrapper.find(".select-item").hide()

        // Update Variant ID on the product form
        $form
          .find(`#product__options-${product_id}`)
          .val(variant_id)
          .trigger("change")

        // Update Prices
        var variant_price = parseFloat($variant.data("price"))
        if ($form.find(".delivery-frequency").length) {
          var discount_percent = parseInt(
            $form.find(".delivery-frequency").data("discount")
          )
          var discounted_price =
            (variant_price * (100 - discount_percent)) / 100

          $form.find(".flexitem-rc__onetime").text(`$${variant_price}`)
          $form
            .find(".flexitem-rc__autodeliver")
            .text(`$${discounted_price.toFixed(2)}`)
        } else {
          $form.find(".price").text(`$${variant_price}`)
        }

        Product.updateFormsViaDropdown(this)
      })

    $(".frequency").click(function () {
      $(this)
        .closest(".delivery-frequency")
        .find(".frequency")
        .removeClass("selected")
      $(this).addClass("selected")
      $(this).closest(".product-info").find(".formCartAdd").hide()
      $(this)
        .closest(".product-info")
        .find('form[data-frequency="' + $(this).attr("data-frequency") + '"]')
        .show()
      $("#autoskip").val($(this).attr("data-autoskip"))

      $(".frequency-title").text($(this).attr("data-frequency-title"))
      $("[data-totalprice-display]").text(
        $(".product-info .formCartAdd:visible [data-price-display]").text()
      )
    })

    $(".fixed-bar .add-to-cart").click(function () {
      $('.product-info .formCartAdd:visible .button[type="submit"]').trigger(
        "click"
      )
    })

    $(".quantity-container .select-item").click(function () {
      $("#quantity").val($(this).attr("data-quantity"))
    })

    $(document).ready(function () {
      if ($("body").hasClass("template-product")) {
        var currentScroll = $(window).scrollTop()
        if ($(".product_form + .five-icons").length > 0) {
          var product_info =
            $(".product_form + .five-icons").offset()["top"] +
            $(".product_form + .five-icons").height()
        } else {
          var product_info =
            $(".product_form").offset()["top"] + $(".product_form").height()
        }
        var productInfoOffset =
          $(".product-info").offset().top + $(".product-info").outerHeight()
        $(window).scroll(function (event) {
          if ($(".product-info.moving").length > 0) {
            var bottomDifference =
              $(window).scrollTop() + $(window).height() - productInfoOffset
            if (
              bottomDifference >= 0 &&
              bottomDifference <=
                $(".product-info").parent().outerHeight() -
                  $(".product-info").outerHeight()
            ) {
              $(".product-info.moving").css("top", bottomDifference)
            } else if (bottomDifference < 0) {
              $(".product-info.moving").css("top", 0)
            } else if (
              bottomDifference >
              $(".product-info").parent().outerHeight() -
                $(".product-info").outerHeight()
            ) {
              $(".product-info.moving").css(
                "top",
                $(".product-info").parent().outerHeight() -
                  $(".product-info").outerHeight()
              )
            }
          }

          // scrolling down
          if (
            currentScroll < $(window).scrollTop() &&
            currentScroll > product_info
          ) {
            $(".product_form .fixed-bar").addClass("open")

            // scrolling up
          } else {
            $(".product_form .fixed-bar").removeClass("open")
          }

          currentScroll = $(window).scrollTop()
        })
        $(window).resize(function (e) {
          product_info =
            $(".product_form").scrollTop() + $(".product_form").height()
        })

        if (typeof productOptions != "undefined") {
          for (var i = 0; i < productOptions.length; i++) {
            const vowels = ["a", "e", "i", "o", "u"]
            let indef = "a"
            const firstOptionLetter = productOptions[i][i][0].toLowerCase()
            if (vowels.includes(firstOptionLetter)) {
              indef = "an"
            }
            $(".single-option-selector:eq(" + i + ")")
              .filter(function () {
                return $(this).find("option").length > 1
              })
              .prepend(
                `<option value="">Select a ${indef} ${productOptions[i][i]}</option>`
              )
              .val("")
              .trigger("change")
          }
        }

        // -- Click first variant to adjust for OOS first load glitch
        if (document.querySelector(".product_form .variants a.selected-item")) {
          // Variant Dropdown support
          var initId = document
            .querySelectorAll(".product_form .variants a.selected-item")[0]
            .getAttribute("data-init-variant")
          if (typeof initId !== undefined && initId !== false) {
            $(
              '.product_form .variants .select-item[data-variant-id="' +
                initId +
                '"]'
            ).click()
          }
        } else if (
          document.querySelector(
            ".product_form .variants .flexitem.select-item"
          )
        ) {
          // 2 or 3 Variant Support
          $(".product_form .variants .flexitem.select-item.selected").click()
        }
      }

      var $memberOverlay = $(".membership-exclusive-overlay")
      if ($memberOverlay.length > 0) {
        $memberOverlay.css("opacity", 1)
      }
    })
  },

  setSlick: function (slick) {
    this.product_images = slick

    $(".product_images").on(
      "beforeChange",
      function (event, slick, currentSlide, nextSlide) {
        var $variant_image = $(this)
          .find('.slick-slide[data-slick-index="' + nextSlide + '"]')
          .find("[data-variant-id]")
        $(
          '.variants .select-item[data-option1="' +
            $variant_image.attr("data-option1") +
            '"][data-option2="' +
            $variant_image.attr("data-option2") +
            '"][data-option3="' +
            $variant_image.attr("data-option3") +
            '"]'
        ).trigger("click")
      }
    )
  },

  updateForms: function (that) {
    $(that)
      .closest(".product-info")
      .find('form input[name="id"]')
      .val($(that).attr("data-variant-id"))

    $(that)
      .closest(".product-info")
      .find('input[data-option="1"]')
      .val($(that).attr("data-option1"))
    $(that)
      .closest(".product-info")
      .find('input[data-option="2"]')
      .val($(that).attr("data-option2"))
    $(that)
      .closest(".product-info")
      .find('input[data-option="3"]')
      .val($(that).attr("data-option3"))

    $(".variant-title").text($(that).attr("data-variant-title"))

    // update images
    if (this.product_images) {
      if ($(that).attr("data-variant-id") !== undefined) {
        var index = $(".product_images")
          .find('[data-variant-id="' + $(that).attr("data-variant-id") + '"]')
          .closest(".slick-slide")
          .attr("data-slick-index")
      } else {
        var index = $(".product_images")
          .find(
            '[data-option1="' +
              $(that).attr("data-option1") +
              '"][data-option2="' +
              $(that).attr("data-option2") +
              '"][data-option3="' +
              $(that).attr("data-option3") +
              '"]'
          )
          .closest(".slick-slide")
          .attr("data-slick-index")
      }
      this.product_images.slickGoTo(index)
    }

    if (
      $(that).attr("data-variant-id") != undefined &&
      Helpers.getUrlParam(window.location.href, "variant") !=
        $(that).attr("data-variant-id")
    ) {
      console.log(
        "trying to change var id",
        $(that).attr("data-variant-id"),
        Helpers.getUrlParam(window.location.href, "variant")
      )
      let isInMain = false
      document
        .querySelectorAll("#shopify-section-product div[data-variant-id]")
        .forEach((el) => {
          if (
            el.getAttribute("data-variant-id") ==
            $(that).attr("data-variant-id")
          ) {
            isInMain = true
          }
        })

      if (isInMain) {
        history.replaceState(
          {},
          "",
          "?variant=" + $(that).attr("data-variant-id")
        )
      }
    }
  },

  updateFormsViaDropdown: function (that) {
    // update images
    if (this.product_images) {
      if ($(that).attr("data-variant-id") !== undefined) {
        var index = $(".product_images")
          .find('[data-variant-id="' + $(that).attr("data-variant-id") + '"]')
          .closest(".slick-slide")
          .attr("data-slick-index")
      } else {
        var index = $(".product_images")
          .find(
            '[data-option1="' +
              $(that).attr("data-option1") +
              '"][data-option2="' +
              $(that).attr("data-option2") +
              '"][data-option3="' +
              $(that).attr("data-option3") +
              '"]'
          )
          .closest(".slick-slide")
          .attr("data-slick-index")
      }
      this.product_images.slickGoTo(index)
    }

    if (
      $(that).attr("data-variant-id") != undefined &&
      Helpers.getUrlParam(window.location.href, "variant") !=
        $(that).attr("data-variant-id")
    ) {
      let isInMain = false
      document
        .querySelectorAll("#shopify-section-product div[data-variant-id]")
        .forEach((el) => {
          if (
            el.getAttribute("data-variant-id") ==
            $(that).attr("data-variant-id")
          ) {
            isInMain = true
          }
        })

      if (isInMain) {
        history.replaceState(
          {},
          "",
          "?variant=" + $(that).attr("data-variant-id")
        )
      }
    }
  },

  contains(parent, child) {
    return parent !== child && parent.contains(child)
  },
}

export default Product
